export default __webpack_public_path__ + "images/DJ.bee356c.png";